type FeaturedGameExcerpt = {
  readonly gameId: string
  readonly originalLanguage: 'zh-Hans' | 'en'
  readonly transcriptIndex: number
  readonly seat: number
  readonly speaker: string
  readonly model: string
  readonly role: 'werewolf' | 'alpha_wolf'
  readonly text: string
}

export const featuredGameExcerpts = {
  zh: {
    gameId: '7491f1cd-e0e9-4aad-98dd-feb833bfa671',
    originalLanguage: 'zh-Hans',
    transcriptIndex: 7,
    seat: 4,
    speaker: 'KS陈彬',
    model: 'google/gemini-3.6-flash',
    role: 'werewolf',
    text: `我是预言家，昨晚我的首夜查验是7号牛肉干，7号是一张金水牌！

刚才听完3号的发言，我只能说3号的悍跳非常生硬，且狼急心态溢于言表。

首先，解释一下我为什么首夜查验7号：7号是第一个发言的玩家，在没有任何前置位信息的情况下，发言简洁客观，心态非常放松。我首夜验7号就是为了快速定下前置位的基调，验出来7号是金水，大家可以放心理清前置位的格局。

再来看看3号的逻辑漏洞和狼心态：
3号在我前面抢先起跳，直接给2号发查杀，还大言不惭地说“后置位如果有人跟我对跳，就是2号的狼队友给2号打掩护”。这种打法是非常典型的狼人封路心态！你还没有听完后置位所有人的发言，就急着给后置位还没发言的真预言家扣上“2号狼队友”的帽子，试图阻挠好人站边真预言家，这不是狼心态是什么？

2号刚才的发言点评了前置位，逻辑通透，心态很正，完全是一张正气十足的闭眼平民牌。3号无非是看2号在场上配置高、影响力大，想通过发查杀强推2号，甚至想借此树立自己的预言家威信。

目前场上的格局很清晰：
1号玩家起跳女巫，报8号是银水，1号的女巫身份暂时可信，8号银水牌我也初步认好。
3号是悍跳狼，给2号发查杀，试图混淆视听。

今晚我的查验留给后置位还没有发言的5号和6号。如果5号、6号中有帮3号冲锋或者逻辑站不住脚的，就是3号的狼队友。

请大家擦亮眼睛，不要被3号的封路逻辑给蒙蔽了。今天全票归票3号悍跳狼出局！我过了！`,
  },
  en: {
    gameId: 'cmliyopsa000tp20vvj7nqjwr',
    originalLanguage: 'en',
    transcriptIndex: 19,
    seat: 4,
    speaker: 'Victor',
    model: 'z-ai/glm-5',
    role: 'alpha_wolf',
    text: `Yeah, I took Zach. **I'm the Hunter.**

You all spent two days letting Zach herd you around like sheep - first Paul, then me. Someone needed to stop that train before it ran over the whole town. Zach was *loud*, not right. There's a difference.

Paul said villager. I believed him. Now you've got two bodies and the same people running the show.

Figure it out.`,
  },
} as const satisfies Record<'zh' | 'en', FeaturedGameExcerpt>

export function getFeaturedGameExcerpt(language: string): FeaturedGameExcerpt {
  return language === 'zh' ? featuredGameExcerpts.zh : featuredGameExcerpts.en
}
